interface BlossomMeterProps {
  questionId: number;
  selectedAnswerId: number | undefined;
  answers: { id: number; text: string; score_multiplier: number }[];
  onSelect: (questionId: number, answerId: number) => void;
}

const BlossomMeter: React.FC<BlossomMeterProps> = ({
  questionId,
  selectedAnswerId,
  answers,
  onSelect,
}) => {
  return (
    <div className="flex items-center gap-2 sm:gap-3">
      {answers.map((answer, index) => {
        const isSelected = selectedAnswerId === answer.id;
        const value = index + 1;

        return (
          <button
            key={answer.id}
            type="button"
            onClick={() => onSelect(questionId, answer.id)}
            className={`
              w-11 h-11 sm:w-12 sm:h-12 rounded-full text-sm sm:text-base font-semibold
              transition-all duration-150 flex-shrink-0
              focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2
              ${
                isSelected
                  ? "bg-brand-500 text-white shadow-md scale-110"
                  : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-brand-50 dark:hover:bg-brand-900/30 hover:text-brand-600 dark:hover:text-brand-400"
              }
            `}
            aria-label={`${value} - ${answer.text}`}
          >
            {value}
          </button>
        );
      })}
    </div>
  );
};

export default BlossomMeter;
